import { WsSendType, IWsPacket } from '../client'

type IAuthPacketData = { sid: string }
type IAuthPacket = IWsPacket<IAuthPacketData>

export function authPacket(sid: string): IAuthPacket {
    return {
        type: WsSendType.Auth,
        data: { sid },
        message: 'auth',
    }
}
